<template>
    <div>
        <v-row >
            <v-col>
                <client-specialist-list :items="client.specialists" @clientSpecialistSelected="handleSpecialistSelected"/>
            </v-col>
        </v-row>
        <v-row  class="mt-3">
            <v-col>
                <v-btn color="success" @click="handleCreateSpecialistButtonClick">Add specialist</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import ClientSpecialistList from '../Components/ClientSpecialistList'

    export default {
        name: "ClientSpecialists",
        props: {
            client: Object
        },
        components: {
            ClientSpecialistList
        },
        methods: {
            handleCreateSpecialistButtonClick() {
                this.$router.push({path: `/clients/${this.client.id}/specialists/add`})
            },
            handleSpecialistSelected(specialistId) {
                this.$router.push({
                    path: `/clients/${this.client.id}/specialists/${specialistId}/edit`
                })
            }
        }
    }
</script>

<style scoped>

</style>